module.exports = __webpack_public_path__ + "img/ll-step-one-img.86a78ef.svg";